<template>
  <div class="dialog-mask" v-if="dialogVisible" @click.self="dialogVisible = false">
    <div class="route-dialog">
      <div class="dialog-header">
        <span class="dialog-title">加入学习路线</span>
        <el-button type="primary" class="new-btn" @click="showNewInput">
          <img src="@/assets/LIST_ADD.png" alt="" class="btn-icon">
          新建学习路线
        </el-button>
      </div>

      <div class="route-list">
        <!-- 统一列表循环 -->
        <div
          class="route-item"
          v-for="(item, index) in routeList"
          :key="item.id || index"
          :class="{ active: item.active }"
          @click="selectRoute(index)"
        >
          <!-- 编辑状态：只有自定义路线且正在编辑才显示输入框 -->
          <div class="route-left" v-if="item.id !== 0 && editItemId === item.id">
            <i class="el-icon-star-off"></i>
            <el-input
              v-model="editRouteName"
              placeholder="请输入新名称"
              size="mini"
              @keyup.enter.native="confirmEditRoute"
            ></el-input>
          </div>

          <!-- 正常显示：默认路线 + 非编辑自定义路线 -->
          <div class="route-left" v-else>
            <i
              :class="item.active ? 'el-icon-star-on' : 'el-icon-star-off'"
              :style="{color: item.active ? '#3355ff' : '#909399'}"
            ></i>
            <span class="route-name">{{ item.name }}</span>
          </div>

          <!-- 自定义路线的操作按钮（和截图样式完全一致） -->
          <div v-if="item.id !== 0" class="action-group">
            <el-button link v-if="editItemId === item.id" @click.stop="confirmEditRoute">
              <i class="el-icon-check"></i>
            </el-button>
            <div v-else class="action-buttons">
              <el-button class="rename-btn" @click.stop="startEdit(item)">
                <i class="el-icon-edit"></i>
                重命名
              </el-button>
              <el-button class="delete-btn" @click.stop="deleteRoute(item)">
                <i class="el-icon-delete"></i>
                删除
              </el-button>
            </div>
          </div>
        </div>

        <div class="route-item new-item" v-if="showInput">
          <div class="route-left">
            <i class="el-icon-star-off"></i>
            <el-input
              v-model="newRouteName"
              placeholder="自定义学习路线"
              size="mini"
              @keyup.enter.native="confirmNewRoute"
            ></el-input>
          </div>
          <el-button link @click="confirmNewRoute">
            <i class="el-icon-check"></i>
          </el-button>
        </div>
      </div>
    </div>

    <el-button type="primary" class="confirm-btn" @click="confirmJoin">
      立即加入学习路线
    </el-button>
  </div>
</template>

<script>
  import {eidtCate, collectAdd, collectCate, collectDelCate} from '@/api/api'

  export default {
    name: "index",
    data() {
      return {
        dialogVisible: false,
        showInput: false,
        newRouteName: '',
        id: '',
        routeList: [
          {name: '默认学习路线', active: true, id: 0},
        ],
        editItemId: 0,
        editRouteName: '',
      }
    },
    methods: {
      show(news_id) {
        this.id = news_id
        this.dialogVisible = true
        this.showInput = false
        this.newRouteName = ''
        this.editItemId = 0
        this.collectCate()
      },
      collectCate() {
        collectCate().then(res => {
          this.routeList = [{name: '默认学习路线', active: true, id: 0}]
          const customList = res.data.list || []
          customList.forEach(item => {
            item.active = false
            this.routeList.push(item)
          })
        })
      },
      selectRoute(index) {
        this.routeList.forEach(i => i.active = false)
        this.routeList[index].active = true
      },
      showNewInput() {
        this.showInput = true
        this.newRouteName = ''
        this.editItemId = 0
      },
      confirmNewRoute() {
        if (!this.newRouteName.trim()) {
          this.$message.warning('请输入学习路线名称')
          return
        }
        let params = {id: 0, name: this.newRouteName}
        eidtCate(params).then(() => {
          this.collectCate()
          this.showInput = false
          this.$message.success('新建成功')
          setTimeout(() => window.location.reload(), 500)
        })
      },
      startEdit(item) {
        if (item.id === 0) return
        this.editItemId = item.id
        this.editRouteName = item.name
        this.showInput = false
      },
      confirmEditRoute() {
        if (!this.editRouteName.trim()) {
          this.$message.warning('请输入新名称')
          return
        }
        let params = {id: this.editItemId, name: this.editRouteName}
        eidtCate(params).then(() => {
          this.collectCate()
          this.editItemId = 0
          this.$message.success('修改成功')
          setTimeout(() => window.location.reload(), 500)
        })
      },
      confirmJoin() {
        const selected = this.routeList.find(item => item.active)
        if (!selected) {
          this.$message.warning('请先选择一条学习路线')
          return
        }
        let params = {
          id: this.id,
          cate_id: selected.id
        }
        collectAdd(params).then(() => {
          this.$message.success(`已加入「${selected.name}」`)
          this.dialogVisible = false
        })
        setTimeout(() => window.location.reload(), 500)
      },
      deleteRoute(item) {
        if (item.id === 0) {
          this.$message.warning('默认学习路线不能删除')
          return
        }
        this.$confirm('此操作将永久删除该学习路线,下方课程将自动移到默认学习路线, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          collectDelCate({id: item.id}).then(() => {
            this.collectCate()
            this.$message.success('删除成功')
            setTimeout(() => window.location.reload(), 500)
          })
        })
      },
    },
  }
</script>

<style scoped lang="less">
  .dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }

  .route-dialog {
    background: #fff;
    border-radius: 20px;
    width: 420px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
  }

  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .dialog-title {
      font-size: 18px;
      font-weight: 500;
    }

    .new-btn {
      border-radius: 8px;
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 8px 16px;
    }

    .btn-icon {
      width: 16px;
      height: 16px;
    }
  }

  .route-list {
    .route-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      border-bottom: 1px solid #eee;
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }



      .route-left {
        display: flex;
        align-items: center;
        gap: 10px;

        i {
          font-size: 20px;
        }

        .route-name {
          font-size: 16px;
          color: #333;
        }
      }

      &.active {
        padding: 10px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        background: #D4DBFE;
        .route-name {
          color: #3355ff;
        }
      }

      .action-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .action-buttons {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .rename-btn {
        color: #3355ff;
        border: 1px solid #3355ff;
        background: #fff;
        border-radius: 4px;
        padding: 4px 12px;
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        height: auto;

        &:hover {
          background: rgba(51, 85, 255, 0.05);
        }
      }

      .delete-btn {
        color: #f56c6c;
        border: 1px solid #f56c6c;
        background: #fff;
        border-radius: 4px;
        padding: 4px 12px;
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        height: auto;

        &:hover {
          background: rgba(245, 108, 108, 0.05);
        }
      }
    }

    .new-item {
      padding: 8px 0;
    }
  }

  .confirm-btn {
    margin-top: 16px;
    width: 420px;
    height: 50px;
    border-radius: 12px;
    font-size: 16px;
    background-color: #3355ff;
    border: none;
  }
</style>
